export const formatCurrency = (value, { currency = 'EUR' } = {}) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency,
  }).format(value);
};
